import React from 'react';
import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import ProgressSpinner
  from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import useGrantAccess from './useGrantAccess';

/* istanbul ignore next */
function GrantAccessModal(props) {
  const {
    hasAdvancedRoles,
    onClose,
    isSamlSubscription,
    isQuote,
    resourceId,
  } = props;

  const {
    errorMessage,
    successMessage,
    submitting,
    grantAccess,
    updateEmailAddress,
    emailAddress,
  } = useGrantAccess();

  return (
    <>
      <Modal
        show
        onHide={onClose}
        animation={false}
      >
        <Modal.Header>
          <div className="row">
            <div className="col mx-auto text-center">
              <h3>Grant Account Access</h3>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          {isSamlSubscription ? (
            <div className="alert alert-primary">
              Because your organization has a federated account,
              access can only be granted through your identity provider.
            </div>
          )
            : (
              <>
                {' '}
                <div className="row mb-4">
                  <div className="col">
                    Enter the email address of the user you&apos;d like to share access with.
                    If they already have a Room Alert Account profile, they will
                    immediately be added to your account with
                    <a href="https://avtech.com/articles/23734/" target="_blank" rel="noopener noreferrer">
                      {hasAdvancedRoles
                        ? (<span> a billing</span>)
                        : (<span> an administrator</span>)}
                      {' '}
                      role.
                    </a>
                  </div>
                </div>
                <div className="form-inline row mb-2">
                  {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                  <label className="col-form-label col-auto">
                    <b>
                      Email
                    </b>
                  </label>
                  <div className="col">
                    <input
                      type="email"
                      onChange={updateEmailAddress}
                      className="form-control w-100"
                      value={emailAddress}
                      disabled={submitting}
                    />
                  </div>
                </div>
                {errorMessage != null && (
                <div className="form-inline row text-danger">
                  <div className="col offset-2">
                    <small>
                      {errorMessage}
                    </small>
                  </div>
                </div>
                )}
                {successMessage && (
                  <div className="form-inline row text-success">
                    <div className="col offset-2">
                      {successMessage}
                    </div>
                  </div>
                )}
              </>
            )}
        </Modal.Body>
        <Modal.Footer>
          <div className="row">
            {isSamlSubscription ? (
              <div className="col ml-auto">
                {' '}
                <Button
                  variant="secondary"
                  onClick={onClose}
                >
                  Close
                </Button>
                {' '}

              </div>
            ) : (
              <div className="col ml-auto">
                <Button
                  variant="secondary"
                  onClick={onClose}
                >
                  Cancel
                </Button>
                {' '}
                <Button
                  style={{ width: '92px' }}
                  variant="primary"
                  onClick={() => grantAccess(isQuote, resourceId)}
                  disabled={submitting}
                >
                  {submitting
                    ? (<div className="row d-flex justify-content-center"><ProgressSpinner useSmallSpinner progressText="" /></div>)
                    : (<>Add User</>)}
                </Button>
              </div>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

GrantAccessModal.propTypes = {
  hasAdvancedRoles: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isSamlSubscription: PropTypes.bool.isRequired,
  isQuote: PropTypes.bool.isRequired,
  resourceId: PropTypes.string.isRequired,
};

export default GrantAccessModal;
